import { computed, type ComputedRef } from "vue";

type Card = { token: string; type?: string; section_token?: string | null; [key: string]: unknown };

export const isLogicCard = (card: Card) => (card.type ?? "").startsWith("o_") || card.type === "q_hidden";

export const isFoldedByDefault = (card: Card) => (card.type ?? "").startsWith("o_");

export const isCompactCard = (card: Card) => ["m_start", "o_typing"].includes(card.type ?? "");

export interface DocumentEntry {
  card: Card;
  sectionToken: string | null;
  sectionName: string | null;
  startsSection: boolean;
}

export function useReviewDocument(
  cards: ComputedRef<Card[]>,
  sections: ComputedRef<{ token: string; name: string }[]>,
) {
  const entries = computed<DocumentEntry[]>(() => {
    const names = new Map(sections.value.map(({ token, name }) => [token, name]));
    let previousSection: string | null | undefined;

    return cards.value.map((card) => {
      const sectionToken = card.section_token ?? null;
      const startsSection = sectionToken !== previousSection;
      previousSection = sectionToken;

      return {
        card,
        sectionToken,
        sectionName: sectionToken ? (names.get(sectionToken) ?? null) : null,
        startsSection,
      };
    });
  });

  return { entries };
}
